function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { colors, spacing, shadows, typography } from '../tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var cardStyle = _objectSpread({
    fontFamily: typography.fontFamily,
    backgroundColor: 'var(--bafkal-bg-surface)',
    borderRadius: '8px',
    border: "1px solid ".concat(colors.neutral[200]),
    boxShadow: shadows.sm,
    padding: spacing.lg
  }, style);
  var headerStyle = {
    marginBottom: spacing.md
  };
  var titleStyle = {
    fontSize: typography.sizes.lg,
    fontWeight: 600,
    color: colors.neutral[900],
    margin: 0
  };
  var subtitleStyle = {
    fontSize: typography.sizes.sm,
    color: colors.neutral[500],
    marginTop: spacing.xs
  };
  return /*#__PURE__*/_jsxs("div", {
    style: cardStyle,
    className: className,
    children: [(title || subtitle) && /*#__PURE__*/_jsxs("div", {
      style: headerStyle,
      children: [title && /*#__PURE__*/_jsx("h3", {
        style: titleStyle,
        children: title
      }), subtitle && /*#__PURE__*/_jsx("p", {
        style: subtitleStyle,
        children: subtitle
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
}